import { HTTP_ERROR_CODES_MAP } from "./constants";
import { AxiosError } from "axios";

export const detailAxiosErrorText = (error) => {
  const msg =
    error.response &&
    [400, 403, 404].indexOf(error.response.status) !== -1 &&
    error.response.data &&
    error.response.data.detail;
  if (Array.isArray(msg)) {
    return msg.join("\n");
  }
  return msg;
};

const getStatusText = (status) => HTTP_ERROR_CODES_MAP[status];

export const getAxiosErrorMessage = (error) => {
  const message = error.message || "Error";
  return detailAxiosErrorText(error) || getStatusText(error.response?.status) || message;
};

export const getAxiosAuthConfig = (email, password) => ({
  auth: { username: email, password: password },
});

/**
 * Checking that is a Network Error. These errors should not be sent to Sentry.
 *
 * @param {AxiosError} error
 */
export const isNetworkError = (error) =>
  !error.response?.status && error.code === AxiosError.ERR_NETWORK;
